import { initMap, equalCols } from '../functions';
import Swal from 'sweetalert2'
// import { Waypoint } from 'waypoints'
// const Waypoint = require('waypoints/lib/noframework.waypoints');

$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

$( () => {

	//waypoint-element
	if($('.waypoint-box').length > 0) {
		$(".waypoint-box-wrapper").each(function() {
			if ($(this).find('.images-wrapper').length < 1) {
				$(this).prev().addClass('waypoint-element');
			}
		});
		if ($(window).width() > 768) {
			var elementArr = [];
			$(".waypoint-box-wrapper").each(function(index) {
				var hasImage = false;
				if ($(this).find('.images-wrapper').length > 0) {
					hasImage = true;
				}

				var element = this;
				elementArr[index] = new Waypoint.Inview({
					element: $(element).find('.waypoint-box'),
					enter: function(direction) {
						if (direction == 'down') {
							if (hasImage) {
								$(element).find('.waypoint-element').addClass('sticky-top');
							} else {
								$(element).prev('.waypoint-element').addClass('sticky-top');
							}
							$(this.element).addClass('active');
						}
					},
					exited: function(direction) {
						if (hasImage) {
							$(element).find('.waypoint-element').removeClass('sticky-top');
						} else {
							$(element).prev('.waypoint-element').removeClass('sticky-top');
						}
						$(this.element).removeClass('active');
					}
				});
			});
		}
	}

	// TITLE ANIMATE

	if($('.animated-title').length > 0) {
		let animatedTitle = new Movinwords({
			el: '.animated-title',
			transition: 'fadeIn',
			delay: 200,
			autostart: false,
			offset: 150
		});
		var inviewTitle = new Waypoint.Inview({
			element: $('.template-banner--default')[0],
			enter: function(direction) {
				animatedTitle.start();
			},
		})
	}

	// document.querySelectorAll(".playPauseBtn").forEach(button => {
	// 	button.addEventListener("click", function () {
	// 		const currentVideo = this.previousElementSibling; // Select the video before the button

	// 		document.querySelectorAll("video").forEach(video => {
	// 			if (video !== currentVideo) {
	// 				video.pause();
	// 				// Also reset the play button icon for other buttons
	// 				const btn = video.nextElementSibling;
	// 				if (btn && btn.classList.contains("playPauseBtn")) {
	// 					btn.innerHTML = '<i class="fas fa-play"></i>';
	// 				}
	// 			}
	// 		});
			
	// 		if (currentVideo.paused || currentVideo.ended) {
	// 			currentVideo.play();
	// 			// this.textContent = "Pause";
    //         	button.innerHTML = '<i class="fas fa-pause"></i>'; // Change icon to pause
	// 		} else {
	// 			currentVideo.pause();
	// 			button.innerHTML = '<i class="fas fa-play"></i>'; // Change icon to play
	// 			// this.textContent = "Play";
	// 		}
	// 	});
	// });
	// TITLE ANIMATE

	const searchInput = document.getElementById("s-query");
    const searchContainer = document.querySelector(".header-search");

	searchInput.addEventListener("focus", function () {
        if (window.innerWidth <= 768) {
            searchContainer.classList.add("search-expanded");
        }
    });

    searchInput.addEventListener("blur", function () {
        if (window.innerWidth <= 768) {
            setTimeout(() => searchContainer.classList.remove("search-expanded"), 200);
        }
    });

	
	// $(".toggle-drop").click(function(){
	// 	$(this).siblings('ul').slideToggle();

    // });

	if (typeof websiteAlertObject !== 'undefined' && websiteAlertObject.enabled == 1) {
		const alertDismissedKey = 'websiteAlertDismissed';

		// Check if the alert has already been dismissed
		if (!sessionStorage.getItem(alertDismissedKey)) {
			Swal.fire({
				html: websiteAlertObject.text,
				showConfirmButton: (websiteAlertObject.buttonText != '' ? true : false),
				confirmButtonText: websiteAlertObject.buttonText,
				showCloseButton: true,
				closeButtonHtml: '&times;',
			}).then((result) => {
				// Mark the alert as dismissed
				sessionStorage.setItem(alertDismissedKey, 'true');

				if (result.isConfirmed && websiteAlertObject.buttonUrl != '') {
					window.location.href = websiteAlertObject.buttonUrl;
				}
			});
		}
	}

});



// WEBPACK FOOTER //
// ./resources/assets/js/regular/general.js